import * as THREE from "three";
import {DXF_VARS} from "../../Global/variables";

/**
 * Projects the given feature's polygon from 3D to 2D based on pre-defined U and V vectors.
 * The result is a set of 2D points corresponding to the feature's original polygon.
 */
export function projectFeatureTo2D(feature) {

    // Map the polygon's 3D points to 2D by projecting onto the U and V vectors
    let projectedPoints = feature.polygon.map(point => {
        point = new THREE.Vector3(point.x, point.y, point.z); // Convert the point to a 3D vector
        const x = point.dot(DXF_VARS.vectorU); // Project the point onto the U vector (X-axis in 2D)
        const y = point.dot(DXF_VARS.vectorV); // Project the point onto the V vector (Y-axis in 2D)
        return new THREE.Vector2(x, y); // Return the projected point as a 2D vector
    });

    // Ensure the polygon is closed by adding the first point at the end
    projectedPoints.push(projectedPoints[0]);

    // Position the projected feature relative to its origin and return the result
    return featPositioning(projectedPoints);
}

/**
 * Adjusts the position of the feature by translating and rotating it based on the origin
 * and rotation angle stored in DXF_VARS.
 */
function featPositioning(feat) {
    // Get the origin of the polygon from DXF_VARS
    let origin = DXF_VARS.origin;
    
    // Create a translation vector to move the feature relative to the origin
    const translationVector = new THREE.Vector2(-origin.x, -origin.y);

    // Translate the feature's points with respect to the origin
    const featPosition = feat.map(point => {
        const translatedPoint = point.clone().add(translationVector); // Translate the point
        return {x: translatedPoint.x, y: translatedPoint.y}; // Return the translated point
    });

    // Get the rotation angle stored in DXF_VARS
    let lineAngle = DXF_VARS.rotationAngle;

    // Rotate the translated feature's points by the calculated rotation angle
    const rotatedFeat = featPosition.map(point => {
        // Apply the rotation matrix to each point
        const rotatedX = Math.cos(-lineAngle) * point.x - Math.sin(-lineAngle) * point.y;
        const rotatedY = Math.sin(-lineAngle) * point.x + Math.cos(-lineAngle) * point.y;
        return new THREE.Vector3(rotatedX, rotatedY, point.z); // Return the rotated point as a 3D vector
    });

    // If the feature was vertically flipped, flip the Y-coordinate of each point
    if (DXF_VARS.isVerticalFlipped) {
        rotatedFeat.forEach(point => {
            point.y = -point.y; // Flip the Y-coordinate
        });
    }

    // Return the final transformed feature
    return rotatedFeat;
}
